import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconColumns3"><Path d="M8 21H3V3H8V21Z" fill="currentColor"/><Path d="M14.5 3V21H9.5V3H14.5Z" fill="currentColor"/><Path d="M21 21H16V3H21V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3;
